import Login from './views/Login.vue'
import NotFound from './views/404.vue'
import HomeIn from './views/HomeIn.vue'
import HomeOut from './views/HomeOut.vue'
import Main from './views/Main.vue'
import Adv from './views/adv/index.vue'
import Channel from './views/adv/channel.vue'
import user from './views/user/user.vue'
import echarts from './views/charts/echarts.vue'

let routes = [
    {
        path: '/login/:token?',
        component: Login,
        name: '',
        hidden: true
    },
    {
        path: '/404',
        component: NotFound,
        name: '',
        hidden: true
    },
	
	{ 
	  path: '/detail/:device_id/:id', 
	  component: HomeIn,
	  leaf: true,
	  hidden: true,
      children: [
            { path: '/', component: () => import('@/views/user/detail.vue'), name: '' },
        ]
	},
	{ 
	  path: '/rules/toutiao/:name', 
	  component: HomeIn,
	  leaf: true,
	  hidden: true,
      children: [
            { path: '/', component: () => import('@/views/rules/toutiao/edit.vue'), name: '' },
        ]
	},
	
	{ 
	  path: '/rules/facebook/:name',
	  component: HomeIn,
	  leaf: true,
	  hidden: true,
      children: [
            { path: '/', component: () => import('@/views/rules/facebook/edit.vue'), name: '' },
        ]
	},
	{ 
	  path: '/rules/adwords/:name', 
	  component: HomeIn,
	  leaf: true,
	  hidden: true,
      children: [
            { path: '/', component: () => import('@/views/rules/adwords/edit.vue'), name: '' },
        ]
	},
	{ 
	  path: '/rules/tiktok/:name', 
	  component: HomeIn,
	  leaf: true,
	  hidden: true,
      children: [
            { path: '/', component: () => import('@/views/rules/tiktok/edit.vue'), name: '' },
        ]
	},
	{ 
	  path: '/adgroup/tiktok/:name',
	  component: HomeIn,
	  leaf: true,
	  hidden: true,
      children: [
            { path: '/', component: () => import('@/views/advertiser/adgroup/tiktok/edit.vue'), name: '' },
        ]
	},
	{ 
	  path: '/adgroup/facebook/:name', 
	  component: HomeIn,
	  leaf: true,
	  hidden: true,
      children: [
            { path: '/', component: () => import('@/views/advertiser/adgroup/facebook/edit.vue'), name: '' },
        ]
	},	
	{ 
	  path: '/rules/toutiao/edit/:name', 
	  component: HomeIn,
	  leaf: true,
	  hidden: true,
      children: [
            { path: '/', component: () => import('@/views/rules/toutiao/edit.vue'), name: '' },
        ]
	},
	
	{ 
	  path: '/run/toutiao/:name', 
	  component: HomeIn,
	  leaf: true,
	  hidden: true,
      children: [
            { path: '/', component: () => import('@/views/rules/toutiao/create.vue'), name: '' },
        ]
	},
	{
        path: '/home',
        component: HomeIn,
        name: '主页概览',
        iconCls: 'el-icon-s-home',
		leaf: false,
		children: [
				{ path: '/home', component:()=>import('@/views/home/index.vue'), name: '主页概览' }
			]
    },
	{ 
	  path: '/advertiser/index', 
	  component: HomeIn,
	  name:'广告管理',
	  leaf: true,
	  iconCls: 'el-icon-s-platform',
      children: [
            { path: '/advertiser/:channel/:advertiser_id', component: () => import('@/views/advertiser/index.vue'), name: '广告列表' },
			{ path: '/advertiser/rule', component: () => import('@/views/advertiser/rule/index.vue'), name: '运行规则' },
			{ path: '/advertiser/account', component: () => import('@/views/advertiser/account.vue'), name: '账户授权' },
			{ path: '/advertiser/adlib', component: () => import('@/views/advertiser/adlib.vue'), name: '广告素材库' },			
        ]
	},
	{ 
	  path: '/report', 
	  component: HomeIn,
	  name:'效果报表',
	  leaf: true,
	  iconCls: 'el-icon-data-analysis',
      children: [
            { path: '/drop_panel', component: () => import('@/views/report/report.vue'), name: '自义定报表' },
			
        ]
	},
	{ 
	  path: '/library', 
	  component: HomeIn,
	  name:'资源管理',
	  leaf: true,
	  iconCls: 'el-icon-video-camera',
      children: [
            { path: '/library', component: () => import('@/views/material/index.vue'), name: '素材库' },
			{ path: '/image_lib', component: () => import('@/views/material/image.vue'), name: '图片库' },
			{ path: '/official', component: () => import('@/views/material/official.vue'), name: '文案库' },
			{ path: '/tag', component: () => import('@/views/material/tag.vue'), name: '创意标签' },
			{ path: '/landingpage', component: () => import('@/views/material/landingpage.vue'), name: '落地页' }
        ]
	},
	{ 
	  path: '/app', 
	  component: HomeIn,
	  name:'预警设置',
	  leaf: true,
	  iconCls: 'el-icon-bell',
      children: [
            { path: '/appwarn', component: () => import('@/views/app/index.vue'), name: '应用预警' },
			{ path: '/comment', component: () => import('@/views/app/comment.vue'), name: '评分预警' },
        ]
	},
	{ 
	  path: '/set', 
	  component: HomeIn,
	  name:'设置',
	  leaf: true,
	  iconCls: 'el-icon-setting',
      children: [
            { path: '/aa', component: () => import('@/views/404'), name: '个人信息' },
			
        ]
	},
	{ 
	  path: '/advertiser/rule/channel/:name',
	  component: HomeIn,
	  leaf: true,
	  hidden: true,
      children: [
            { path: '/advertiser/rule/channel/:name', component: () => import('@/views/advertiser/rule/create.vue'), name: '' },
        ]
	},
	{ 
	  path: '/admin/edit', 
	  component: HomeOut,
	  leaf: true,
	  hidden:true,
	  iconCls:'fa fa-cog',
      children: [
            { path: '/admin/edit', component: () => import('@/views/admin/edit.vue'), name: '个人设置中心' },
        ]
	},
   
	{ path: '/message', 
	  component: HomeIn,	  
	  name:'消息通知',
	  iconCls: 'el-icon-menu',
	  leaf: true,
	  hidden:true,
	  children: [
            { path: '/message', component: () => import('@/views/message/index.vue'), name: '消息通知' }
        ] 
	},
	{
        path: '/',
        component: HomeIn,
        name: '管理员列表',
        iconCls: 'el-icon-user',
		leaf: true,
		hidden:true,
		children: [
				{ path: '/adminuser', component:()=>import('@/views/admin/index.vue'), name: '管理员列表' }
			]
    },
		{ path: '/audience',
		component: HomeOut,
		name:'自定义受众',
		iconCls: 'el-icon-menu',
		leaf: true,
		hidden:true,
		children: [
			{ path: '/audience', component: () => import('@/views/audience/index.vue'), name: '受众' }
		]
	},
	{ path: '/audience/file/:id',
		component: HomeOut,
		name:'文件受众',
		iconCls: 'el-icon-menu',
		leaf: true,
		hidden:true,
		children: [
			{ path: '/audience/file/:id', component: () => import('@/views/audience/file.vue'), name: '文件受众' }
		]
	},
	{ path: '/audience/page/:id',
		component: HomeOut,
		name:'主页受众',
		iconCls: 'el-icon-menu',
		leaf: true,
		hidden:true,
		children: [
			{ path: '/audience/page/:id', component: () => import('@/views/audience/page.vue'), name: '主页受众' }
		]
	},
	{ path: '/audience/app/:id',
		component: HomeOut,
		name:'事件受众',
		iconCls: 'el-icon-menu',
		leaf: true,
		hidden:true,
		children: [
			{ path: '/audience/app/:id', component: () => import('@/views/audience/app.vue'), name: '事件受众' }
		]
	},
	{ path: '/audience/video/:id',
		component: HomeOut,
		name:'视频受众',
		iconCls: 'el-icon-menu',
		leaf: true,
		hidden:true,
		children: [
			{ path: '/audience/video/:id', component: () => import('@/views/audience/video.vue'), name: '视频受众' }
		]
	},
	{ path: '/lookalike',
		component: HomeOut,
		name:'类似受众',
		iconCls: 'el-icon-menu',
		leaf: true,
		hidden:true,
		children: [
			{ path: '/lookalike', component: () => import('@/views/lookalike/index.vue'), name: '自定义受众' }
		]
	},
	{ path: '/lookalike/existing/:id/:rewrite?',
		component: HomeOut,
		name:'自定义转化',
		iconCls: 'el-icon-menu',
		leaf: true,
		hidden:true,
		children: [
			{ path: '/lookalike/existing/:id/:rewrite?', component: () => import('@/views/lookalike/existing.vue'), name: '自定义转化' }
		]
	},
	{ path: '/lookalike/campaign/:id/:rewrite?',
		component: HomeOut,
		name:'广告转化',
		iconCls: 'el-icon-menu',
		leaf: true,
		hidden:true,
		children: [
			{ path: '/lookalike/campaign/:id/:rewrite?', component: () => import('@/views/lookalike/campaign.vue'), name: '广告转化' }
		]
	},
	{ path: '/lookalike/page/:id/:rewrite?',
		component: HomeOut,
		name:'主页粉丝转化',
		iconCls: 'el-icon-menu',
		leaf: true,
		hidden:true,
		children: [
			{ path: '/lookalike/page/:id/:rewrite?', component: () => import('@/views/lookalike/page.vue'), name: '主页粉丝转化' }
		]
	},
	{ path: '/drop_panel',
		component: HomeOut,
		name:'投放面板',
		iconCls: 'el-icon-menu',
		leaf: true,
		hidden:true,
		children: [
			{ path: '/drop_panel', component: () => import('@/views/drop_panel/index.vue'), name: '自定义受众' }
		]
	},
	
    {
        path: '*',
        hidden: true,
        redirect: { path: '/404' }
    }
];


export default routes;


// WEBPACK FOOTER //
// ./src/routes.js